import React, { Component } from 'react';
import { checkTranslation, msToHMS, translate } from '../../utils/useful';
import { getBoundingClientRect } from '../../utils/functions';
import SocketServices from '../../utils/socket.services';
import { nanoid } from 'nanoid';
import HttpServices from '../../utils/Http.services';
import { ReactMic } from "react-mic";
import { v4 as uuidv4 } from 'uuid';
import moment from 'jalali-moment';
import MessageImageBox from '../views/messenger/boxes/MessageImageBox';
import MessageFileBox from "../views/messenger/boxes/MessageFileBox";
import MessageVideoBox from '../views/messenger/boxes/MessageVideoBox';
import MessageAudioBox from '../views/messenger/boxes/MessageAudioBox';
import MessageTextBox from '../views/messenger/boxes/MessageTextBox';
import MessageSystemInfo from '../views/messenger/boxes/MessageSystemInfo';
import MessengerDropModal from '../views/messenger/MessengerDropModal';
import MessageAudioBoxNew from '../views/messenger/boxes/MessageAudioBoxNew';
import MessageTextBoxNew from '../views/messenger/boxes/MessageTextBoxNew';

class MultiContentInput extends Component {

    state = {
        text: '',
        inputHeight: 37,
        current: 'text',
        time: 0,
        isRecord: false,
        pauseRecord: false,
        recordInProgress: false,
        attachmentsList: [
            { name: '{{lang}}messenger.Yonnect drive', icon: '/assets/icons/messenger/folder-a-gray.svg', function: 'attachDrive' },
            { name: '{{lang}}messenger.Album', icon: '/assets/icons/messenger/photo-a-gray.svg', function: 'attachAlbum' },
            { name: '{{lang}}messenger.File', icon: '/assets/icons/messenger/doc-a-gray.svg', function: "attachFile" },
            { name: '{{lang}}messenger.Location', icon: '/assets/icons/messenger/location-a-gray.svg', function: 'doNothing' },
        ],
        searchValue: '',
        messengerId: nanoid(),
        showSelect: false,
        selectList: [],
        data: []
    }

    init() {

        this.setState({ showNewMessagesBox: null, data: [], currentPage: 0, totalCount: null, filter: null, isOnLast: false }, () => {
        })
    }

    handleKeyDownChange = (e) => {
        if (e.keyCode === 13 && e.shiftKey) {
            e.preventDefault();
            this.setState({
                text: `${this.state.text}\n`,
            });
        }

        if (e.keyCode === 13 && !e.shiftKey) {
            e.preventDefault();
            if (this.state.text && this.state.text != '') {
                this.sendTextMessage();
            }

        }
    };

    updateInput = (element) => {
        let shadow = this.inputShadow
        this.setState({ text: element.value }, () => {
            // console.log('---messenger ',this.props.messenger)
            // this.sendNotifToServer(this.props.messenger._id)
            shadow.style.height = 'inherit';
            shadow.style.height = (shadow.scrollHeight) + "px";

            let height = getBoundingClientRect(shadow).height
            if (!element.style) {
                element.style = {}
            }
            element.style.height = height + 'px'
            this.setState({ inputHeight: height })
        })

    }

    sendTextMessage = () => {
        let text = this.state.text
        if (text.trim() != '' && text.trim() != undefined && text.trim() != null) {
            // this.setData('text', text, () => {
            this.changeValue('descriptions', text)
            this.setState({ text: '' }, () => {
                this.inputShadow.style.height = 'inherit'
                this.input.style.height = 'inherit';
                this.input.focus()
                // this.createMessage(rawmessage, (message) => {
                //     this.sendMessageToServer(message)
                // })
            })
            // })
        } else {
            this.setState({ text: '' })
        }
    }

    createMessage = (rawmessage, cb) => {
        if (this.props.messenger) {
            console.log('createMessage')
            const timezoneOffset = (new Date()).getTimezoneOffset();
            let message = {
                sender: this.state.myId,
                senderHub: this.props.variables?.appletHub._id,
                applet: this.props.currentApplet ? this.props.currentApplet : this.props.variables?.applet?._id,
                messenger: this.props.messenger?._id,
                tempId: nanoid(),
                status: 0,
                cDate: new Date().getTime(),
                tz: timezoneOffset,
                trashed: false
            }

            message = { ...message, ...rawmessage }
            cb(message)

        } else {
            this.requestcreateMessenger(0, 1, rawmessage, (info) => {
                this.createMessage(rawmessage, cb)
            })
        }

    }

    sendMessageToServer = (message) => {
        console.log('messssage10', message)

        this.props.actions.addMessages(this.props.messenger?._id, [message])

        SocketServices.sendMessage(this.props.messenger?._id, message)
        this.props.sendNotif('isTyping', false, this.props.messenger._id, () => {
        })
        this.scrollToBottom(true)

    }

    startRecording = () => {
        console.log("startRecording")
        this.setState({ isRecord: true, recordInProgress: true, pauseRecord: false, time: 0 }, () => {
            this.setTimer()
        })
    }

    setTimer() {
        this.timer = setInterval(() => {
            this.setState({ time: this.state.time + 1 })
        }, 1000);
    }

    stopRecording = () => {
        clearInterval(this.timer)
        this.setState({ isRecord: false, }, () => {
            this.setState({ recordInProgress: false })
        })
        this.setState({ pauseRecord: false })
    }

    recordVoice = () => {
        setTimeout(() => {
            this.element.startWave()
        }, 400);
        this.startRecording()
    }

    pauseRecord = () => {
        if (this.state.pauseRecord) {
            this.setTimer()
        } else {
            clearInterval(this.timer)
        }
        this.setState({ pauseRecord: !this.state.pauseRecord })
    }

    cancelVoice = () => {
        this.setState({ cancelVoice: true }, () => {
            setTimeout(() => {
                this.setState({ cancelVoice: false })
            }, 200)
        })
    }

    sendVoice = () => {
        this.setState({ recordInProgress: false })
        clearInterval(this.timer)
        console.log("sendVoice")
    }

    onStop = async (recordedBlob) => {
        console.log("onStop")
        console.log("this is blob rec", recordedBlob, this.state.recordInProgress)
        if (!this.state.recordInProgress && this.state.isRecord) {
            let metadata = {
                type: 'audio/mp3',
            };
            if (recordedBlob) {
                console.log('recordedBlob', recordedBlob)
                const voiceMessage = new File([recordedBlob.blob], `${uuidv4()}.mp3`, metadata);
                this.sendFileMessage([voiceMessage], 'voices')
                this.setState({ isRecord: false })
            }
        }
    }

    sendFileMessage = (files, key, text) => {
        console.log('files', files, key, text)
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            let myKey = key
            if (key == 'album') {
                if (file.type.startsWith('image')) {
                    myKey = 'image'
                }
                if (file.type.startsWith('video')) {
                    myKey = 'video'
                }
            }
            let rawmessage = {
                key: myKey,
                tempFile: file,
                text: text && text
            }
            // let data = this.state.data
            // data[key] = file
            this.setData(key, file, () => {
                HttpServices.addUploadQueque(file, { type: 'test', key: myKey }, null, (info) => {
                    console.log('ytpp')
                    this.changeValue(key, info)
                    console.log('dataisss', this.state.data)
                    console.log('info isss', info)
                })
            })
        }
    }
    changeValue = (key, info) => {
        // console.log(e.target.value)
        // let value = this.state.choosen?.value
        // if (value == '') {
        //     value = null
        // }
        let data = this.props.data ?? {}
        // console.log('keyusiis', key)
        if (!data[key]) {
            data[key] = []
        }
        // console.log('infol', info)
        if (Array.isArray(info)) {
            data[key] = [...data[key], ...info]
        } else {
            data[key].push(info)
        }
        // console.log('this.props.changeValue', this.props.changeValue)
        this.props.changeValue(this.props.header.key, data, this.props.extra)
    }


    onData = (e) => {
        console.log(e)
        console.log("this is on data")
    }

    startWave = () => {
        console.log("startWave")
        if (this.state.isRecord == true) {
            this.ctx = this.cnv.getContext("2d");
            let freqs;
            navigator.mediaDevices.enumerateDevices().then(devices => {
                devices.forEach((d, i) => console.log(d.label, i));
                navigator.mediaDevices
                    .getUserMedia({
                        audio: true,
                    })
                    .then(stream => {
                        this.stream = stream;
                        const context = new AudioContext()//(window.AudioContext || window.webkitAudioContext)();
                        const analyser = context.createAnalyser();
                        const source = context.createMediaStreamSource(stream);
                        const biquadFilter = context.createBiquadFilter();
                        biquadFilter.type = "highshelf";
                        biquadFilter.frequency.setValueAtTime(1000, context.currentTime);//.value = 1000;
                        biquadFilter.gain.setValueAtTime(10, context.currentTime)//value = range.value;
                        source.connect(analyser);
                        freqs = new Uint8Array(analyser.frequencyBinCount);
                        const draw = () => {
                            let radius = 25;
                            let bars = 500;
                            if (this.ctx && this.cnv) {
                                this.ctx.clearRect(0, 0, this.cnv.width, this.cnv.height);
                                this.ctx.beginPath();
                                this.ctx.arc(
                                    this.cnv.width / 2,
                                    this.cnv.height / 2,
                                    radius,
                                    0,
                                    2 * Math.PI
                                );
                                this.ctx.stroke();
                                analyser.getByteFrequencyData(freqs);
                                for (var i = 0; i < bars; i++) {
                                    let radians = (Math.PI * 10) / bars;
                                    let bar_height = freqs[i] * 0.06;
                                    let x = this.cnv.width / 2 + Math.cos(radians * i) * radius;
                                    let y = this.cnv.height / 2 + Math.sin(radians * i) * radius;
                                    let x_end = this.cnv.width / 2 + Math.cos(radians * i) * (radius + bar_height);
                                    let y_end = this.cnv.height / 2 + Math.sin(radians * i) * (radius + bar_height);
                                    let color = '#007aff20';
                                    this.ctx.strokeStyle = color;
                                    this.ctx.lineWidth = 3;
                                    this.ctx.beginPath();
                                    this.ctx.moveTo(x, y);
                                    this.ctx.lineTo(x_end, y_end);
                                    this.ctx.stroke();
                                }
                            }
                            requestAnimationFrame(draw);
                        }
                        requestAnimationFrame(draw);
                    });
            });
        } else {
            if (this.stream !== undefined) {
                this.off = () => {//toggle state
                    this.stream.getAudioTracks().forEach(function (track) {
                        track.stop()
                    });
                };
                this.off()
            }
        }
    }

    handleSearchInputChange = (event) => {
        this.setState({ searchValue: event.target.value });
    }

    componentWillUnmount() {
        window.removeEventListener('mousedown', this.checkOusideClicked, true)
    }

    checkOusideClicked = (e) => {
        if (this.wrapperRef && !this.wrapperRef.contains(e.target)) {
            this.forceHide()
        }
    }

    forceHide = () => {
        setTimeout(() => {
            this.showAttachments(false)
        }, 20);
        window.removeEventListener('mousedown', this.checkOusideClicked, true)
    }

    showAttachments = (status) => {
        let newStatus = status == null ? !this.state.showAttachments : status
        this.setState({ showAttachments: newStatus })
        if (newStatus) {
            window.addEventListener('mousedown', this.checkOusideClicked, true)
        }
    }

    doFunction = (prop) => {
        if (prop.function) {
            this[prop.function]()
        }
    }

    doNothing = () => {
        this.forceHide()
    }

    attachAlbum = () => {
        console.log('propssssssssssssss',)
        this.setState({ fileLimit: 'image/*,video/*' }, () => {
            this.uploadInput.click()
        })
    }

    attachFile = () => {
        this.setState({ fileLimit: null }, () => {
            this.uploadInput.click()
        })
    }

    attachFiles = (files) => {
        console.log("files")
        console.log(files)
        let final = []
        if (files) {
            Object.values(files).map((prop, index) => {
                final.push(prop)
            })
        }
        console.log(final)
        this.sendFileMessage(final, 'files')
        // this.changeValue('files', final)
        let withCompression = this.state.fileLimit == null ? false : true
        this.passAttachFiles(final, withCompression)
        this.forceHide()
    }

    passAttachFiles = (files, withCompression, caption) => {
        console.log('aaaaaaaa', files, withCompression, caption)
        this.MessengerDropModal.showModal(files, withCompression, caption)
    }

    selectMessage = (item) => {
        if (!this.state.showSelect) {
            this.setState({ showSelect: true })
        }
        console.log('item', item)
        let selectList = this.state.selectList
        if (selectList.includes(item._id)) {
            let index = selectList.indexOf(item._id)
            selectList.splice(index, 1)
        }
        else {
            selectList.push(item._id)
        }


    }

    editMessageAction = (item) => {
        this.setState({ onEdit: item }, () => {
        })
    }

    deleteMessage = (message, messenger, hub, type, cb) => {
        HttpServices.request('deleteMessage', { message, messenger, hub, type }, (fetchResult, fetchError) => {
            console.log('done')
            cb()
        })
    }

    setData = (key, value, cb) => {
        let data = this.state.data
        data[key] = value
        // data.value = value
        // console.log(this.state[key])
        this.setState({ data }, () => {
            console.log('dataaaa', this.state.data)
            if (cb) {
                cb()
            }

        })
    }

    render() {
        let hasText = this.state.text && this.state.text != ''
        const filteredAttachments = this.state.attachmentsList.filter((attachment) => {
            const attachmentName = translate(attachment.name);
            return attachmentName.toLowerCase().includes(this.state.searchValue.toLowerCase());
        });
        let data = this.state.data
        let time = moment(data?.cDate).format('HH:mm')
        let isOther = false
        return (
            <div>
                 <div className="flexc w-100 mb-2">
                    <button onClick={() => { this.showAttachments() }} className="px-1 flexcc">
                        <img src={'/assets/icons/messenger/paperclip.svg'} style={{ transition: '0.3s all' }} height={30} />
                    </button>
                    <div className="position-relative flex-1 flexc">
                        <div className="position-absolute w-100" style={{ zIndex: -1, bottom: 0 }}>
                            <textarea ref={el => this.inputShadow = el} rows={1} value={this.state.text} className="w-100 mt-0" style={{ opacity: 0, padding: '8px 5px', outline: 'none', resize: 'none', border: 'none', backgroundColor: 'transparent', fontSize: 14, height: '60', maxHeight: 100, color: "#444" }} placeholder={translate("messenger.Message")} />
                        </div>
                        <textarea id={"input-" + this.state.inputId} ref={el => this.input = el} rows={1} value={this.state.text} onKeyDown={e => this.handleKeyDownChange(e)} onChange={(e) => this.updateInput(e.target)} className="w-100 mt-0" style={{ padding: '8px 5px', outline: 'none', resize: 'none', border: 'none', backgroundColor: 'transparent', fontSize: 14, height: '60', maxHeight: 100, color: "#444", }} placeholder={translate("messenger.Message")} />
                    </div>
                    {!hasText && (
                        <div className="px-1 flexcc" >
                            <div className=" h-100 w-100" style={{ position: this.state.isRecord ? "absolute" : "", zIndex: 1, display: "flex", alignItems: "center", justifyContent: "center", background: this.state.isRecord ? "#fff" : "transparent", left: this.state.isRecord ? 0 : "" }}>
                                {this.state.isRecord && (
                                    <>
                                        <div className="flex-1 flexc px-2 position-relative">
                                            <div className="flexc mx-1">
                                                <div className="" style={{ backgroundColor: this.state.pauseRecord ? '#aaa' : '#ee5050', width: 12, height: 12, borderRadius: 10 }}>
                                                </div>
                                                <p className="mx-1 ">{msToHMS(this.state.time)}</p>
                                            </div>
                                        </div>
                                    </>
                                )}
                                {this.state.isRecord ? (
                                    <div style={{ position: "relative", marginRight: -15, }}>
                                        <div style={{ width: "200px", transform: 'translate(70px,70px)', right: 0, bottom: 0, height: "200px", position: "absolute", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                            <canvas id="myCanvas" ref={el => this.cnv = el} width="100" height="100" style={{ opacity: this.state.pauseRecord ? 0 : 1 }}></canvas>
                                        </div>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            <button onClick={() => this.stopRecording()} style={{ marginRight: 10, display: "flex", alignItems: "center", justifyContent: "center", zIndex: 3 }}>
                                                <img style={{ width: 30, height: 30 }} src="/assets/icons/messenger/trash-red.svg" />
                                            </button>
                                            <button onClick={() => this.pauseRecord()} style={{ borderRadius: 50, marginRight: 10, display: "flex", alignItems: "center", justifyContent: "center", zIndex: 3 }}>
                                                {!this.state.pauseRecord ? (
                                                    <img style={{ width: 40, height: 40 }} src="/assets/icons/messenger/pause.circle.fill.svg" />
                                                ) : (
                                                    <img className="" style={{ width: 40, height: 40 }} src="/assets/icons/messenger/play.circle.fill.svg" />
                                                )}
                                            </button>
                                            <button onClick={() => this.sendVoice()} draggable={false} className="px-1 flexcc recordButton pulse" style={{ transition: '0.3s all', position: 'relative', borderRadius: 100, width: 60, height: 60 }}>
                                                <img className="" draggable={false} src={'/assets/icons/messenger/send-black.svg'} style={{ transition: '0.3s all' }} height={40} />
                                            </button>
                                        </div>
                                    </div>
                                ) : (
                                    <button style={{}} onClick={() => this.recordVoice()} className="px-1 flexcc">
                                        <img src={'/assets/icons/messenger/mic.svg'} height={30} />
                                    </button>
                                )}
                                <ReactMic
                                    record={this.state.recordInProgress}
                                    className="d-none"
                                    mimeType="audio/mp3"
                                    onStop={this.onStop}
                                    onData={this.onData}
                                    strokeColor="#000000"
                                    visualSetting="sinewave"
                                    echoCancellation={true}
                                    autoGainControl={true}
                                    noiseSuppression={true}
                                />
                            </div>
                        </div>
                    )}
                    {hasText && (
                        <>
                            {this.state.onEdit ? (
                                <button onClick={() => { if (hasText) { this.editMessage(this.state.onEdit._id, this.props.messenger._id, this.state.text) } }} className="px-1 flexcc">
                                    <img src={'/assets/icons/messenger/send.svg'} style={{ opacity: hasText ? 1 : 0.5, filter: hasText ? '' : 'saturate(0%)', transition: '0.3s all' }} height={30} />
                                </button>
                            ) : (
                                <button onClick={() => { if (hasText) { this.sendTextMessage() } }} className="px-1 flexcc">
                                    <img src={'/assets/icons/messenger/send.svg'} style={{ opacity: hasText ? 1 : 0.5, filter: hasText ? '' : 'saturate(0%)', transition: '0.3s all' }} height={30} />
                                </button>
                            )}
                        </>
                    )}

                    {this.state.showAttachments && (
                        <div ref={el => this.wrapperRef = el} className="position-absolute d-flex flex-column shadow-3" style={this.props.language == 'fa' ? { right: 40, bottom: 55, borderRadius: 10, backgroundColor: '#fff' } : { left: 40, bottom: 55, borderRadius: 10, backgroundColor: '#fff' }}>
                            <div className="w-100">
                                <div className="mt-2 mx-2 top-0" style={{ zIndex: "3" }}>
                                    <div className="" style={{ backgroundColor: '#f6f6f6', borderRadius: 6 }}>
                                        <input className="py-2 px-2 w-100" placeholder={translate('messenger.Search')} value={this.state.searchValue} onChange={this.handleSearchInputChange} style={{ backgroundColor: 'transparent', border: 'none' }} />
                                    </div>
                                </div>

                                <div className="d-flex flex-column w-100" style={{ maxHeight: 200, width: "250px" }}>
                                    {filteredAttachments.map((prop, index) => {
                                        return (
                                            <button style={{ zIndex: "1" }} className=" bb-gray py-1 mx-2" key={index} onClick={() => { this.doFunction(prop) }}>
                                                <div className="flexcb w-100 hover-gray py-2 px-2 br-5">
                                                    <p className="main-c7" >{checkTranslation(prop.name)}</p>
                                                    <img width={20} className="" src={prop.icon} />
                                                </div>
                                            </button>
                                        )
                                    })}
                                </div>
                            </div>

                            <div className="d-none">
                                <input
                                    id="upload-input"
                                    ref={el => this.uploadInput = el}
                                    type="file"
                                    multiple={true}
                                    accept={this.state.fileLimit}
                                    onChange={(e) => { this.attachFiles(e.target.files) }}
                                />
                            </div>
                            <MessengerDropModal ref={el => this.MessengerDropModal = el} height={this.props.height} sendFileMessage={this.sendFileMessage} />

                        </div>
                    )}


                </div>
                <div className='flexc scroll-no-scrollbar w-100'>
                    {this.props.data?.files?.map((element) => {
                        return (

                            <div className='mx-1'>
                                <MessageFileBox data={element} isOther={isOther} time={time} hideStatus={true} />
                            </div>
                        )
                    })}
                </div>

                {(data.image || data.key == 'image') && (
                    <MessageImageBox openModals={this.props.openModals} data={data} isOther={isOther} time={time} />
                )}

                {(data.video || data.key == 'video') && (
                    <MessageVideoBox data={data} isOther={isOther} time={time} />
                )}
                <div className='flexc scroll-no-scrollbar w-100'>
                    {this.props.data?.voices?.map((element) => {
                        return (
                            <div className='mx-1'>
                                <MessageAudioBoxNew data={element} isOther={isOther} time={time} />
                            </div>
                        )
                    })}
                </div>


                {/* {(data.text && !data.file && !data.image) && ( */}
                {this.props.data?.descriptions?.map((element) => {
                    // console.log('elementisvd',element)
                    return (
                        <MessageTextBoxNew hideStatus={true} data={element} isOther={isOther} time={time} />
                    )
                })}
                {/* )} */}
                {data.systemInfo && (
                    <MessageSystemInfo data={data} isOther={isOther} time={time} />
                )}
               
            </div>
        );
    }
}

export default MultiContentInput;